<template>
    <section id="hero">
        <v-img :src="require('@/assets/hero.jpg')" height="100vh">
            <v-toolbar color="transparent" flat>
                <v-spacer></v-spacer>

                <!-- langs change -->
                <v-btn
                    icon
                    type="submit"
                    @click="$i18n.locale = 'pl'"
                    :class="{ 'primary--text': $i18n.locale == 'pl' }"
                >
                    <span>PL</span>
                </v-btn>
                <span>|</span>
                <v-btn
                    icon
                    type="submit"
                    @click="$i18n.locale = 'en'"
                    :class="{ 'primary--text': $i18n.locale == 'en' }"
                >
                    <span>EN</span>
                </v-btn>
            </v-toolbar>

            <v-row
                :justify="$vuetify.breakpoint.mdAndUp ? 'end' : undefined"
                align="end"
                class="fill-height text-right pa-16 mx-4 mx-xs-8 mx-md-0"
            >
                <div>
                    <div
                        :class="`display-${$vuetify.breakpoint.mdAndUp ? '3' : '2'}`"
                        class="text-uppercase"
                        v-text="$t('general.name')"
                    />
                    <h1
                        :class="`display-${$vuetify.breakpoint.mdAndUp ? '4' : '1'}`"
                        class="primary--text text-uppercase"
                        v-text="$t('general.label')"
                    />
                </div>
            </v-row>
        </v-img>
    </section>
</template>

<script>
export default {
    name: 'Hero',
};
</script>

<style lang="scss" scoped></style>
